import _ from 'underscore';
import WindowAbstraction from '@bingads-webui-clientcenter/window-interface';

export type AddIframePreAttachModifier = (iframe: HTMLIFrameElement) => void;

// eslint-disable-next-line func-names
export default function (url: string, preAttachModifier: AddIframePreAttachModifier = _.noop) {
  const iframe = WindowAbstraction.document.createElement('iframe');
  iframe.style.display = 'none';
  preAttachModifier(iframe);
  iframe.src = url;
  WindowAbstraction.document.body.appendChild(iframe);
}
